(() => {
  'use strict';

  const toggle = document.querySelector('[data-or-feed-view-toggle]');
  if (!toggle) return;
  const messages = toggle ? toggle.dataset : {};

  const storageKey = 'orProductFeedView';
  const allowed = ['blank', 'male', 'female'];
  const i18n = {
    openOption: messages.feedMsgOpenOption || 'Open the product to choose an option.',
    adding: messages.feedMsgAdding || 'ADDING…',
    addedToCart: messages.feedMsgAddedToCart || 'ADDED TO CART ✓',
    added: messages.feedMsgAdded || 'ADDED ✓',
    couldNotAdd: messages.feedMsgCouldNotAdd || 'Could not add this option.',
    productView: messages.feedLabelProductView || 'PRODUCT VIEW',
    mensFit: messages.feedLabelMensFit || "MEN'S FIT",
    womensFit: messages.feedLabelWomensFit || "WOMEN'S FIT",
    dedicatedImageComing: messages.feedLabelDedicatedImageComing || 'DEDICATED IMAGE COMING SOON',
    imageComing: messages.feedLabelImageComing || 'IMAGE COMING SOON',
  };

  function preferencesProcessingAllowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.preferencesProcessingAllowed());
    } catch (error) {
      return false;
    }
  }

  function storedView() {
    if (!preferencesProcessingAllowed()) return 'blank';
    try {
      const value = window.localStorage.getItem(storageKey);
      return allowed.includes(value) ? value : 'blank';
    } catch (error) {
      return 'blank';
    }
  }

  let currentView = storedView();

  function saveView(value) {
    if (!preferencesProcessingAllowed()) return;
    try {
      window.localStorage.setItem(storageKey, value);
    } catch (error) {}
  }

  function updateButtons(value) {
    (toggle ? toggle.querySelectorAll('[data-or-feed-view]') : []).forEach((button) => {
      const active = button.dataset.orFeedView === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function applyCardView(card, value) {
    const views = Array.from(card.querySelectorAll('[data-feed-view-image]'));
    if (!views.length) return;

    let target = views.find((node) => node.dataset.feedViewImage === value);
    if (!target) target = views.find((node) => node.dataset.feedViewImage === 'blank') || views[0];

    views.forEach((node) => {
      node.hidden = node !== target;
    });
  }

  function applyCollectionView(value) {
    document.querySelectorAll('[data-feed-card]').forEach((card) => applyCardView(card, value));
  }

  function visibleProductPanels(root) {
    return Array.from(root.querySelectorAll('.product-gallery__panel')).filter((panel) => {
      return panel.dataset.orMediaVisible !== 'false';
    });
  }

  function activateProductPanel(root, panel) {
    if (!panel) return;

    const mediaId = panel.dataset.mediaId;
    if (mediaId) {
      const thumb = root.querySelector('.product-gallery__thumb[data-media-target="' + mediaId + '"]');
      if (thumb) {
        thumb.click();
        return;
      }
    }

    const panels = Array.from(root.querySelectorAll('.product-gallery__panel'));
    panels.forEach((item) => {
      const active = item === panel;
      item.hidden = !active;
      item.classList.toggle('is-active', active);
    });
  }

  function applyProductView(value) {
    const root = document.querySelector('[data-or-product-main]');
    if (!root) return;

    const panels = visibleProductPanels(root);
    if (!panels.length) return;

    const matchesView = (panel, view) => {
      const values = (panel.dataset.feedViews || panel.dataset.feedView || '').split(/\s+/).filter(Boolean);
      return values.includes(view);
    };

    let target = value === 'blank' && root.dataset.merchBack === 'true'
      ? panels.find((panel) => panel.dataset.mediaSide === 'back')
      : null;
    if (!target) target = panels.find((panel) => matchesView(panel, value));
    if (!target && value !== 'blank') target = panels.find((panel) => matchesView(panel, 'blank'));
    if (!target) target = panels.find((panel) => matchesView(panel, 'neutral'));
    if (!target) target = panels[0];

    activateProductPanel(root, target);
  }

  function applyView(value, persist = true) {
    currentView = allowed.includes(value) ? value : 'blank';
    updateButtons(currentView);
    applyCollectionView(currentView);
    applyProductView(currentView);
    document.documentElement.dataset.orProductView = currentView;
    if (persist) saveView(currentView);
  }

  (toggle ? toggle.querySelectorAll('[data-or-feed-view]') : []).forEach((button) => {
    button.addEventListener('click', () => applyView(button.dataset.orFeedView));
  });

  document.querySelectorAll('.or-facets-shell[open]').forEach((details) => {
    details.removeAttribute('open');
  });

  const productRoot = document.querySelector('[data-or-product-main]');
  if (productRoot) {
    productRoot.addEventListener('or:variant-change', (event) => {
      if (event.detail && event.detail.colourChanged) {
        window.requestAnimationFrame(() => applyProductView(currentView));
      }
    });
  }

  const collectionCards = Array.from(document.querySelectorAll('.template-collection #MainContent [data-feed-card]'));
  if (collectionCards.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-feed-current', entry.isIntersecting && entry.intersectionRatio >= 0.58);
      });
    }, { threshold: [0.25, 0.58, 0.85] });
    collectionCards.forEach((card) => observer.observe(card));
  }

  applyView(currentView, false);
})();

